"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Cache store manager.
 */
var CacheStore = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {String} name Store name.
   */
  function CacheStore(name) {
    _classCallCheck(this, CacheStore);

    this.constructor.store[name] = this.constructor.store[name] || new Map();
    this.store = this.constructor.store[name];
  }
  /**
   * Sets a cache item.
   *
   * @param {Object} key Cache key.
   * @param {Object} value Cache value.
   */


  _createClass(CacheStore, [{
    key: "set",
    value: function set(key, value) {
      this.store.set(key, value);
    }
    /**
     * Returns a cache item.
     *
     * @param {Object} key Cache key.
     * @return {Object|Null} Cache value.
     */

  }, {
    key: "get",
    value: function get(key) {
      return this.store.get(key);
    }
    /**
     * Deletes a cache item.
     *
     * @param {Object} key Cache key.
     */

  }, {
    key: "delete",
    value: function _delete(key) {
      this.store.delete(key);
    }
    /**
     * Clears the cache.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.store.clear();
    }
    /**
     * Returns all keys.
     *
     * @return {Object[]} Cache keys.
     */

  }, {
    key: "keys",
    value: function keys() {
      return this.store.keys();
    }
    /**
     * Returns all values.
     *
     * @return {Object[]} Cache values.
     */

  }, {
    key: "values",
    value: function values() {
      return this.store.values();
    }
    /**
     * Returns the amount of values stored in the cache.
     *
     * @return {Number} Amount of values.
     */

  }, {
    key: "size",
    get: function get() {
      return this.store.size;
    }
    /**
     * Returns the store.
     *
     * @return {Object} Cache store.
     */

  }], [{
    key: "clearAll",

    /**
     * Clears all cache.
     */
    value: function clearAll() {
      window.IkeaComponent = window.IkeaComponent || {};
      window.IkeaComponent.$cacheStore = {};
    }
  }, {
    key: "store",
    get: function get() {
      window.IkeaComponent = window.IkeaComponent || {};
      window.IkeaComponent.$cacheStore = window.IkeaComponent.$cacheStore || {};
      return window.IkeaComponent.$cacheStore;
    }
  }]);

  return CacheStore;
}();

exports.default = CacheStore;